<script setup lang="ts">
  import type { HeaderSearchStoryblok } from '@/storyblok/component-types-sb'

  const props = defineProps<{
    item: HeaderSearchStoryblok
  }>()

  const searchQuery = ref('')

  const { isMobile } = useBTBreakpoints()

  async function handleSearch() {
    const href = props.item?.link?.href
    const query = searchQuery.value?.trim()

    if (!href || !query) {
      return
    }

    await navigateTo({ path: href, query: { search: query } }, { external: true })
  }
</script>

<template>
  <div class="w-full space-y-10 md:space-y-6">
    <form
      class="flex flex-col items-stretch gap-x-4 gap-y-4 md:flex-row"
      role="search"
      @submit.prevent="handleSearch"
    >
      <UiInputBase
        v-model="searchQuery"
        class="w-full"
        path="search"
        name="search"
        input-key="form"
        :placeholder="item?.placeholder"
        :aria-label="item?.placeholder"
        :icon="isMobile ? 'common/search' : null"
        autofocus
      />

      <UiButton
        class="h-auto px-6 py-3"
        :title="$t('forms.search')"
        type="submit"
        variant="outlineSecondary"
      >
      </UiButton>
    </form>

    <MainHeaderPopularSearchLinks :links="item.popularSearchLinks ?? []" />
  </div>
</template>
